export default function PHP_Exceptions() {
  return (
    <div>
      <h1>PHP_Exceptions</h1>
    </div>
  );
}
